import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveCcr6Failure, saveCcr6Success, updateCcr6Failure, updateCcr6Success } from './actions';

export function* saveCcr6({ payload }) {
  try {
    yield call(api.post, 'api/ccr6', payload.data, { withCredentials: true });

    yield put(saveCcr6Success());

    toast.success('CCR6 criado com sucesso!')

    history.push('/specifications/pilar3/resources/ccr6');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCcr6Failure());
  }
}

export function* updateCcr6({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/ccr6/${id}`, payload.data, { withCredentials: true });

    yield put(updateCcr6Success());

    toast.success('CCR6 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/ccr6');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateCcr6Failure());
  }
}

export default all([
  takeLatest('@ccr6/SAVE_REQUEST', saveCcr6),
  takeLatest('@ccr6/UPDATE_REQUEST', updateCcr6)
]);